export const capitalizeWord = (word: string | boolean): string => {
    if (word === undefined || (typeof word === 'string' && word.length === 0)) return '';
    let string = typeof word === 'string' ? word : String(word);
    return string[0].toUpperCase().concat(string.slice(1));
};
